// export default {
//     summaryMode:                    gd.session.companies.get(gd.companyId).settings.modules.workload.summaryMode,
//     sortBy:                         null, //{id: 'tasks-number', sort: 'desc'},
//     zoom:                           0.67,
//     systemStatusFilter:             'open',
//     filters:                        {},
//     startDateTodayDiff:             -60,
//     endDateTodayDiff:               120,
// };

import {WorkloadSummaryMode} from "../@const";

export const Workload_DefaultSettings : any = {
    // summaryMode:                    gd.company.settings.modules.workload.summaryMode,
    summaryMode:                    WorkloadSummaryMode.HOURS,
    sortBy:                         null, //{id: 'tasks-number', sort: 'desc'},
    zoom:                           0.67,
    systemStatusFilter:             'open',
    filters:                        {},
    startDateTodayDiff:             -60,
    endDateTodayDiff:               120,
};